import { User } from "@core/users/models/User";

export interface UserResponse {
  id: number;
  firstName: string;
  lastName: string;
  avatarUrl?: string;
}

const toUser = (response: UserResponse): User => new User(response);

export const UserAssembler = {
  toUser
};